

import { Component, Vue, Watch, Prop } from "vue-property-decorator"

import { Team } from "@/types"
import vSelect from "vue-select"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class TeamPermissionsSelector extends Vue {
	@Prop()
	value!: string[] | null

	@Prop({ default: () => [] })
	teams!: Team[]

	@Prop()
	placeholder!: string

	@Prop({ default: false })
	readonly!: boolean

	/**
	 * If value is not null, require it to have at least one team
	 */
	@Prop({ default: false })
	requireTeamsIfSet!: boolean

	get enabled (): boolean {
		return !!this.value
	}
	set enabled (value: boolean) {
		this.$emit("input", value ? (this.value ? this.value : []) : null)
	}

	get label () {
		if (!this.enabled) {
			return "Not enabled"
		}

		if (this.value && this.value.length > 0) {
			return this.value.map(teamId => this.teams.find(t => t.id === teamId))
				.filter(t => !!t)
				.map(t => t!.title)
				.join(", ")
		} else {
			return "Anyone"
		}
	}

	updateValue (newValue: string[]) {
		this.$emit("input", newValue)
	}
}

